/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientSidePathEndpointRequest
 */
export interface ClientSidePathEndpointRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientSidePathEndpointRequest
     */
    serverSidePath: string;
    /**
     * 
     * @type {string}
     * @memberof ClientSidePathEndpointRequest
     */
    platform?: string | null;
}

export function ClientSidePathEndpointRequestFromJSON(json: any): ClientSidePathEndpointRequest {
    return ClientSidePathEndpointRequestFromJSONTyped(json, false);
}

export function ClientSidePathEndpointRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientSidePathEndpointRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serverSidePath': json['server_side_path'],
        'platform': !exists(json, 'platform') ? undefined : json['platform'],
    };
}

export function ClientSidePathEndpointRequestToJSON(value?: ClientSidePathEndpointRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'server_side_path': value.serverSidePath,
        'platform': value.platform,
    };
}


